module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Back"},"ja":{"back":"戻る"}}')
  delete Component.options._Ctor
}
